export class FloorSelectorButton extends Autodesk.Viewing.UI.Button {
	public constructor(id: string, caption: string, public floorLevel: number) {
		super(id);

		this.icon.innerHTML = caption;

		this.addClass("be-toolbar-button");
		this.setDisplay(caption);
	}

	public set active(value: boolean) {
		if (value) {
			this.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
		} else {
			this.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
		}
	}
}
